import React, { FunctionComponent } from 'react';
import { theme } from '@admitkard/ccl/style';
import { Text } from '@admitkard/ccl/Text';
import { Button } from '@admitkard/ccl/Button';
import { AkHead } from 'components/AkHead';
import { Img } from '@admitkard/ccl/Img';
import Router from 'next/router';

const _404: FunctionComponent = (_props) => {
  const goToPreviousRoute = () => {
    Router.push('/');
  };
  return <>
    <div className="error-page-wrapper">
      <AkHead />
      <div className="error-page-wrapper__content-section">
        <Text
          variant='xl'
          className='error-page-wrapper__text'
          display='block'
          weight='bold'>
          Uh Oh! Page not found!
        </Text>
        <Button
          color="secondary"
          className="error-page-wrapper__action-btn"
          key="lor-writers"
          size="large"
          variant='contained'
          onClick={goToPreviousRoute}
        >
          Go Back
        </Button>
        <div className="error-page-wrapper__error-image-container">
          <Img
            className="error-page-wrapper__error-image"
            alt="404 - Page Not Found" src="images/404_error.svg" />
        </div>
      </div>
    </div>
    <style jsx>{`
      .error-page-wrapper {
        height: 100vh;
        display: flex;
        padding: ${theme.spacingOld(6)} 0;
        background-color: ${theme.palette.grey[20]};
      }
      .error-page-wrapper__content-section {
        display: flex;
        flex-direction: column;
        width: 90%;
        margin: auto;
        align-items: center;
        overflow: hidden;
      }
      .error-page-wrapper__text {
        text-align: center;
        max-width: 375px;
      }
      .error-page-wrapper__action-btn {
        max-width: 50%;
        margin: ${theme.spacingOld(4)} 0 ${theme.spacingOld(4)};
      }
      :global(.error-page-wrapper__error-image) {
        margin-top: ${theme.spacingOld(7)};
        width: 100%;
      }
    `}</style>
  </>;
};

export default _404;
